// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1561) return "static/chunks/1561-353a4185f1b48824.js";
	// return url for filenames based on template
	return "static/chunks/" + "da458701" + "." + "72613691a5621da9" + ".js";
};